import { Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
var InspeccionService = /** @class */ (function () {
    function InspeccionService(_http) {
        this._http = _http;
        this.url = GLOBAL.url;
    }
    InspeccionService.prototype.getTipoIngreso = function () {
        var headers = new Headers({
            'Content-Type': 'application/json',
        });
        console.log('Inspeccion Service', this.url);
        return this._http.get(this.url + 'tipoIngreso', { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    InspeccionService.prototype.crearInspeccion = function (data) {
        //console.log(data)
        var headers = new Headers({
            'Content-type': 'application/json',
        });
        return this._http.post(this.url + 'save/inspeccion', data, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    return InspeccionService;
}());
export { InspeccionService };
